module.exports = __webpack_public_path__ + "static/img/health1.54d9d83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/health1.png
// module id = 0eRh
// module chunks = 0